import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, getCurrentInstance, withDefaults } from 'vue';
import type {
    FormColumn,
    DropdownOption,
    CrewFormSubmitData,
} from '@/modules/Logistics/interfaces/LogisticsInterfaces';
import { VEHICLE_TYPE_OPTIONS, VEHICLE_PURPOSE_OPTIONS } from '@/modules/Logistics/composables/LogisticsTableHelper';


export default /*#__PURE__*/_defineComponent({
  __name: 'CrewFormModal',
  props: {
    visible: { type: Boolean },
    section: null,
    columns: null,
    record: { default: null },
    vehicleOptions: { default: () => [] },
    initialFormData: { default: () => ({}) }
  },
  emits: ["close", "create", "update"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'close'): void;
    (e: 'create', data: CrewFormSubmitData): void;
    (e: 'update', data: CrewFormSubmitData): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { visible: boolean, section: 'vehicles' | 'teams', columns: FormColumn[], record: any, vehicleOptions: DropdownOption[], initialFormData: Record<string, any> };





const { proxy } = getCurrentInstance()!;
const loading = ref(false);

const isEditMode = computed(() => props.record !== null && props.record.id !== undefined);

const modalTitle = computed(() => {
    if (props.section === 'vehicles') {
        return isEditMode.value ? proxy.$t('Edit Vehicle') : proxy.$t('New Vehicle');
    }
    return isEditMode.value ? proxy.$t('Edit Montage Team') : proxy.$t('New Montage Team');
});

const formFields = computed(() => {
    return props.columns.filter((col) => col.type);
});

function getDropdownOptions(dataIndex: string): DropdownOption[] | [] {
    if (dataIndex === 'vehicleId') {
        return props.vehicleOptions || [];
    }
    if (dataIndex === 'type') {
        return VEHICLE_TYPE_OPTIONS;
    }
    if (dataIndex === 'purpose') {
        return VEHICLE_PURPOSE_OPTIONS;
    }

    return [];
}

function handleSubmit() {
    loading.value = true;

    const submitData = {
        formData: { ...props.initialFormData },
        row: props.record ?? null,
    };

    if (isEditMode.value) {
        emit('update', submitData);
    } else {
        emit('create', submitData);
    }

    loading.value = false;
    emit('close');
}

function handleCancel() {
    emit('close');
}

return { __sfc: true,props, emit, proxy, loading, isEditMode, modalTitle, formFields, getDropdownOptions, handleSubmit, handleCancel }
}

})